export default __webpack_public_path__ + "static/Corprate_Careers-Stores_03-105d93f09c6a2f8ba5175a3490ca0736.jpg";